import {html} from "../_snowpack/pkg/ube.js";
export const NotFound = {
  name: "not-found",
  template: () => html`Not found`
};
